import request from './index'

// export const entityList = (entityId, pageIndex, pageSize, params, fuzzySearch) => {
export const entityList = listQuery => {
  return request({
    url: '/entity/list',
    method: 'post',
    data: {
      command_id: 46,
      entityId: listQuery.entityId,
      pageIndex: listQuery.pageIndex,
      pageSize: listQuery.pageSize,
      params: listQuery.params,
      fuzzySearch: listQuery.fuzzySearch
    }
  })
}

export const getEntityTree = (entityId) => {
  return request({
    url: '/entity/treeList',
    method: 'post',
    data: {
       entityId:entityId
    }
  })
}

export const getEntityData = (entityId) => {
  return request({
    url: '/entity/info',
    method: 'post',
    data: {
      entityId
    }
  })
}

export const addEntity = formEntityData => {
	return request({
		url:'/entity/addEntity',
		method:'post',
		data:{
			command_id: 60,
			parentId:formEntityData.editParentId,
			editEntityId:formEntityData.editEntityId,
			addEntityName: formEntityData.addEntityName,
			addEntityShortName:formEntityData.addEntityShortName,
			addAddress: formEntityData.addAddress,
			addContacts: formEntityData.addContacts,
			addPhone: formEntityData.addPhone,
			addManHour:formEntityData.addManHour,
			addDesc:formEntityData.addDesc,
			addLng:formEntityData.addLng,
			addLat:formEntityData.addLat,
			addNetPic:formEntityData.addNetPic,
			addLogo:formEntityData.addLogo,
			addLogoTit:formEntityData.addLogoTit,
			addLogoAdt:formEntityData.addLogoAdt,
			addLogoScn:formEntityData.addLogoScn
		}
	})
}

export const pauseEntity = (entityId) => {
	return request({
		url:'/entity/pauseEntity',
		method:'post',
		data:{
			command_id: 61,
			entityId:entityId
		}
	})
}


export const deleteEntity = (entityId) => {
	return request({
		url:'/entity/deleteEntity',
		method:'post',
		data:{
			command_id: 62,
			entityId:entityId
		}
	})
}

export const getCreditsLog = (entityId)=>{
	return request({
		url:'/entity/credits/logs/'+entityId,
		method:'get',
	})
}

export const updateEntity = entity => {
	return request({
		url:'/entity/updateEntity',
		method:'post',
		data:entity,
	})
}